import { Building2, EyeOff, FlaskConical, Sparkles } from "lucide-react";
import type { TenantClassification } from "@ubisafe/shared";

const labels: Record<TenantClassification, string> = {
  CLIENT: "Cliente",
  POC: "POC",
  TRIAL: "Trial",
  IGNORED: "Ignorado",
};

const icons = {
  CLIENT: Building2,
  POC: FlaskConical,
  TRIAL: Sparkles,
  IGNORED: EyeOff,
} as const;

interface TenantClassificationBadgeProps {
  classification: TenantClassification;
}

export function TenantClassificationBadge({ classification }: TenantClassificationBadgeProps) {
  const Icon = icons[classification];
  return (
    <span className={`tenant-badge tenant-badge--${classification.toLowerCase()}`}>
      <Icon aria-hidden="true" />
      {labels[classification]}
    </span>
  );
}

export const tenantClassificationLabels = labels;
